module.exports = __webpack_public_path__ + "static/media/MaterialCommunityIcons.5752a580.ttf";